export enum ContentWidth {
  CONTENT_WIDTH_UNKNOWN = 'CONTENT_WIDTH_UNKNOWN',
  /**
   * 1280px on desktop web. Used for standard homepage and category pages.
   */
  DESKTOP_STANDARD = 'DESKTOP_STANDARD',
  /**
   * 1376px on desktop web. Equivalent to 1440px (XL breakpoint) minus 32px padding.
   */
  DESKTOP_LARGE = 'DESKTOP_LARGE',
  /**
   * 1920px on desktop web.
   */
  DESKTOP_XLARGE = 'DESKTOP_XLARGE',
}
